module.exports = __webpack_public_path__ + "media/theme/how-it-works-close-03-f664efc4.png";